import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import ConfirmSettlementBannerImage from 'assets/images/ConfirmSettlementBannerImage.png';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const ConfirmSettlementCompleted = (props) => {
  let {
    bannerDetails,
    setShowSettlement,
    setOpenSettlement,
    isAgentDashboard,
    proeprtyID,
  } = props;
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const ConfirmTicIcon = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_38210_159899)">
          <path
            d="M5 12L10 17L20 7"
            stroke="#4898F8"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_38210_159899">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.isFromConfirmSettlement) {
      setOpenSettlement(true);
      setShowSettlement(true);
    }
  }, []);

  const ConfirmSettlementRedirection = (propertyId) => {
    if (propertyId) {
      history.push({
        pathname: `/dashboard/view-dashboard/${propertyId}`,
        state: {
          isFromConfirmSettlement: true,
        },
      });
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={8} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1.5 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    marginTop: matchessm && '-60px',
                  }}
                >
                  {bannerDetails?.propertyAddress}.
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  Confirm Settlement Completed
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  Verify settlement has completed successfully for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 600 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {bannerDetails?.propertyAddress}
                  </Typography>
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={matchessm ? 9 : 2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                  >
                    Extend
                  </Button>

                  <Box display="flex" alignItems="center">
                    <Button
                      onClick={() => {
                        if (isAgentDashboard) {
                          ConfirmSettlementRedirection(proeprtyID);
                        } else {
                          setOpenSettlement(true);
                          setShowSettlement(true);
                        }
                      }}
                      startIcon={<ConfirmTicIcon />}
                      sx={{
                        px: 4,
                        height: matchessm ? 35 : 42,
                        borderRadius: '5px',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                        border: '1px solid #E6F2FF',
                        backgroundColor: '#FFF',
                        color: '#4898F8',
                        fontFamily: 'poppins',
                        '&:hover': {
                          bgcolor: '#FFF',
                          color: '#4898F8',
                        },
                      }}
                    >
                      Mark as Settled
                    </Button>
                  </Box>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={ConfirmSettlementBannerImage}
                alt="ConfirmSettlementBannerImage"
                style={{ objectFit: 'contain', height: '275px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default ConfirmSettlementCompleted;
